import { gql } from '@apollo/client'
import { Coproprietaire } from '../fragment/coproprietaire.fragment'

export const FOURNISSEUR_DEMANDE_QUERY = gql`
  query FournisseurDemande($trigramme: String!) {
      d4_societe(where: {_and: {interventions: {demande: {copropriete: {trigramme: {_eq: $trigramme}}, datecloturedefinitive: {_is_null: true}, dtype: {_neq: "Dossier"}}, dateannulation: {_is_null: true}, dateinterventionrealisee: {_is_null: true}, facturefournisseur_id: {_is_null: true}}}}, order_by: {raisonsociale: asc}) {
        raisonsociale
        id
        mail1
        mail2
        interventions(where: {_and: {demande: {copropriete: {trigramme: {_eq: $trigramme}}, datecloturedefinitive: {_is_null: true}, dtype: {_neq: "Dossier"}}, dateannulation: {_is_null: true}, dateinterventionrealisee: {_is_null: true}, facturefournisseur_id: {_is_null: true}}}) {
          id
          demande {
            description
            id
          }
        }
      }
    }
`;

const SocieteFragment = gql`
  fragment Societe on d4_societe {
    id
    raisonsociale
    mail1
    mail2
    telfixe
    telportable
    codecmc7
    agence
    fax
    lieu
    representant_id
    comptevision {
      actif
    }
    coproprietaire {
      ...CoproprietaireLots
    }
  }
  ${Coproprietaire.fragments.coproprietaire}
`

export const SOCIETE_DETAIL_BY_ID = gql`
  query Societe($ids: [bigint!]!) {
    societes: d4_societe(where: { id: { _in: $ids } }) {
      ...Societe
    }
  }
  ${SocieteFragment}
`

export const SOCIETE_DETAIL_BY_TEL = gql`
  query Societe($tel: String!) {
    societeDetail: d4_societe(where: { _or: [{ telportable: { _like: $tel } }, { telfixe: { _like: $tel } }] }) {
      ...Societe
    }
  }
  ${SocieteFragment}
`

export const SOCIETE_SEARCH = gql`
  query SocieteSearch($search: String!) {
    societes: d4_lot(
      distinct_on: copropriete_id
      order_by: { copropriete_id: asc }
      where: { lot_coproprietaire: { coproprietaire: { societe: { raisonsociale: { _ilike: $search } } } } }
    ) {
      id
      lot_coproprietaire {
        coproprietaire {
          societe {
            id
            raisonsociale
            representant_id
            dtype
          }
        }
      }
      copropriete_id
      copropriete {
        id
        trigramme
      }
    }
  }
`

export const FOURNISSEUR_SEARCH = gql`
  query FournisseurSearch($search: String!) {
    fournisseurs: d4_societe(
      where: { _and: [{ dtype: { _eq: "Fournisseur" } }, { raisonsociale: { _ilike: $search } }] }
    ) {
      id
      raisonsociale
      representant_id
      dtype
    }
  }
`
